<script>
    export default {
        name: "HomePartners",
        computed: {
            partners() {
                return [
                    { icon: "madrobots", link: "https://madrobots.ru/brands/finamill" },
                    {
                        icon: "ozon",
                        link: "https://www.ozon.ru/seller/medrobots-6333/brand/finamill-101146581/",
                    },
                    // { icon: "wb", link: "" },
                    {
                        icon: "ym",
                        link: "https://market.yandex.ru/search?generalContext=t%3DshopInShop%3Bi%3D1%3Bbi%3D882361%3B&text=Finamill&rs=eJwzEvjEyMvBKLDwEKsEg8b7Oz9YnWS5JLnYOJglWBVYBRSk2FNS0xJLc0oUGDQYjBgEGL04LA0SDZNTU5ODjAzNjS2MjY1NzY0NLYz0DZPSjBMNLC3NTZMNky3SjFKNzU2MDE2NDQyNUgzMDAz0DfUNAY3XGU8%2C&businessId=882361&searchContext=sins_ctx",
                    },
                    // { icon: "mega-market", link: "" },
                    // { icon: "restore", link: "" },
                    // { icon: "technopark", link: "" },
                ];
            },
        },
    };
</script>

<template>
    <section id="partners" class="home-partners l-container">
        <div class="home-partners__inner">
            <h2 class="home-partners__title"><span>Не откладывайте</span> покупку!</h2>

            <div class="home-partners__subtitle">
                Электрические мельницы FinaMill и&nbsp;контейнеры FinaPod уже в&nbsp;продаже
                у&nbsp;наших партнеров
            </div>

            <div class="home-partners__list">
                <a
                    v-for="partner in partners"
                    :key="partner.icon"
                    class="home-partners__link"
                    :href="partner.link"
                    target="_blank"
                >
                    <img
                        :src="`/static/finamill/assets/home/partners/${partner.icon}.png`"
                        alt=""
                    />
                </a>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .home-partners {
        &__inner {
            padding: 48px 16px 60px;
            @include bp($bp-desktop-sm) {
                padding: 72px 16px 85px;
            }
        }

        &__title {
            max-width: 280px;
            margin: 0 auto 16px;
            font-size: 24px;
            font-weight: 600;
            line-height: 30px;
            text-align: center;

            span {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    z-index: -1;
                    left: -3px;
                    right: 0;
                    bottom: 2px;
                    height: 12px;
                    background-color: #f8d548;
                    @include bp($bp-desktop-sm) {
                        height: 16px;
                    }
                }
            }

            @include bp($bp-desktop-sm) {
                max-width: 100%;
                font-size: 34px;
                line-height: 44px;
                span {
                    &::after {
                        left: -5px;
                        bottom: -1px;
                    }
                }
            }
        }

        &__subtitle {
            max-width: 300px;
            margin-bottom: 16px;
            font-family: var(--secondary-font);
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            @include bp($bp-desktop-sm) {
                max-width: 580px;
                margin: 0 auto 36px;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
            }
        }

        &__list {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -14px -28px;

            @include bp($bp-desktop-sm) {
                justify-content: center;
                gap: 38px;
                margin: 0;
            }
        }

        &__link {
            flex-basis: calc(33.3333% - 28px);
            max-width: calc(33.3333% - 28px);
            margin: 0 14px 28px;
            border-radius: 18px;
            overflow: hidden;
            transition: transform 0.2s ease-in;
            transform-origin: top;
            &:hover {
                transform: scale(1.15);
            }

            @include bp($bp-desktop-sm) {
                flex-basis: 92px;
                max-width: 92px;
                width: 92px;
                height: 92px;
                margin: 0;
            }
        }
    }
</style>
